// extracted by mini-css-extract-plugin
module.exports = {"container":"PageSection_container___QZ5a","image":"PageSection_image__ltMv1","title":"PageSection_title__f45Gq"};